import { render } from "./Carriers.vue?vue&type=template&id=1850841a&scoped=true"
import script from "./Carriers.vue?vue&type=script&lang=js"
export * from "./Carriers.vue?vue&type=script&lang=js"

import "./Carriers.vue?vue&type=style&index=0&id=1850841a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1850841a"]])

export default __exports__